import _objectSpread from "/Users/manojvivek/workspace/react-prefetcher/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _defineProperty2 from "/Users/manojvivek/workspace/react-prefetcher/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/manojvivek/workspace/react-prefetcher/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/manojvivek/workspace/react-prefetcher/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/manojvivek/workspace/react-prefetcher/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/manojvivek/workspace/react-prefetcher/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "/Users/manojvivek/workspace/react-prefetcher/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/manojvivek/workspace/react-prefetcher/demo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Fragment } from 'react';
var loadedUrls = {};

var Prefetcher =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Prefetcher, _React$Component);

  function Prefetcher(props) {
    var _this;

    _classCallCheck(this, Prefetcher);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Prefetcher).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "_delay", _this.props.delayMs || 500);

    _defineProperty(_assertThisInitialized(_this), "_eventHappened", function (event) {
      return setTimeout(function () {
        return _this.setState(_defineProperty2({}, event + 'ed', true));
      }, _this._delay);
    });

    _defineProperty(_assertThisInitialized(_this), "_prefetchAssets", function (assets) {
      if (!assets) {
        return null;
      }

      if (assets.constructor !== Array) {
        return _this._renderPrefetch(assets);
      }

      return assets.map(_this._renderPrefetch).filter(Boolean);
    });

    _defineProperty(_assertThisInitialized(_this), "_renderPrefetch", function (href) {
      if (typeof href === 'object') {
        _this._processCustomFetcher(href);

        return null;
      }

      if (!href || loadedUrls[href]) {
        return;
      }

      return React.createElement("link", {
        key: href,
        rel: "prefetch",
        href: href,
        onLoad: function onLoad() {
          return loadedUrls[href] = true;
        },
        as: "image"
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_processCustomFetcher", function (config) {
      if (typeof config.fetcher !== 'function') {
        console.warn('Invalid config to prefetch:', config);
        return;
      }

      if (loadedUrls[config.href]) {
        return;
      }

      config.fetcher();
      loadedUrls[config.href] = true;
    });

    _this.state = {
      rendered: false,
      hovered: false,
      clicked: false
    };
    return _this;
  }

  _createClass(Prefetcher, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this._eventHappened('render');
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return React.createElement(Fragment, null, React.createElement("span", {
        onMouseEnter: function onMouseEnter() {
          return _this2._eventHappened('hover');
        },
        onClick: function onClick() {
          return _this2._eventHappened('click');
        },
        className: this.props.className,
        style: _objectSpread({
          width: 'max-content'
        }, this.props.style)
      }, this.props.children), this.state.rendered && this._prefetchAssets(this.props.onRenderAssets), this.state.hovered && this._prefetchAssets(this.props.onHoverAssets), this.state.clicked && this._prefetchAssets(this.props.onClickAssets));
    }
  }]);

  return Prefetcher;
}(React.Component);

export { Prefetcher as default };